<template>
  <div class="text-center">
    <v-dialog v-model="isOpen" scrollable persistent max-width="900px">
      <v-card>
        <v-toolbar flat dark color="primary">
          <v-toolbar-title>
            <v-icon left>mdi-file-document-edit</v-icon>แบบฟอร์มส่งคำขอเป็น Teacher/Tutor
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="isClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <warnningComponent
            v-bind:textInfo.sync="textWarning"
            v-bind:typestatus.sync="typeWarning"
            v-bind:alert.sync="showWarnnig"
          ></warnningComponent>
          <v-form ref="form" v-model="valid">
            <v-container>
              <p class="subtitle-1 mb-0">ข้อมูลทั่วไป</p>
              <v-row>
                <v-col lg="2" cols="2">
                  <div class="img-padding pt-3">
                    <v-avatar size="80">
                      <v-img
                        :src="info.image"
                        class="my-2 ml-auto mr-auto rounded-card img-md"
                        aspect-ratio="1"
                      ></v-img>
                    </v-avatar>
                  </div>
                </v-col>

                <v-col lg="8" cols="8">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <p
                          class="ma-2 px-5 md-fixed-width text-left font-weight-bold title"
                        >{{info.name}}</p>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <p class="ma-2 px-5 md-fixed-width text-left subtitle">{{info.email}}</p>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col lg="2" cols="2">
                  <div class="img-padding">
                    <v-chip class="my-5" color="default">
                      <v-avatar left>
                        <v-icon>mdi-account</v-icon>
                      </v-avatar>
                      <p class="mb-0">ผู้ใช้ทั่วไป</p>
                    </v-chip>
                  </div>
                </v-col>
              </v-row>

              <v-divider class="mb-5"></v-divider>
              <p class="subtitle-1">อัปโหลดหลักฐาน</p>
              <v-row>
                <v-col lg="6" md="6" sm="6" cols="12" class="p-relative">
                  <p>หลักฐานที่ 1</p>
                  <v-file-input
                    :rules="fileRules"
                    accept="image/png, image/jpeg, image/bmp"
                    v-model="imageFiles1"
                    v-on:change="processFile"
                    prepend-icon="mdi-camera"
                    label="เลือกรูปภาพ"
                    class="p-absolute center-row full-width"
                    outlined
                    rounded
                    dense
                    show-size
                  ></v-file-input>
                </v-col>
                <v-col lg="6" md="6" sm="6" cols="12">
                  <v-card class="ma-5" :color="`grey lighten-2`" elevation="3">
                    <v-img
                      :src="imgPreview1 == null ? imageReady1 : imgPreview1"
                      :lazy-src="imgPreview1"
                      aspect-ratio="1"
                      contain
                      height="190"
                    >
                      <template v-slot:placeholder>
                        <v-row class="fill-height ma-0" align="center" justify="center">
                          <!-- <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular> -->
                          <v-icon
                            v-if="imageReady1"
                            class="mx-auto"
                            elevation="3"
                            size="190"
                          >mdi-card-account-details-outline</v-icon>
                        </v-row>
                      </template>
                    </v-img>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col lg="6" md="6" sm="6" cols="12" class="p-relative">
                  <p>หลักฐานที่ 2</p>
                  <v-file-input
                    :rules="fileRules"
                    v-on:change="processFile2"
                    accept="image/png, image/jpeg, image/bmp"
                    prepend-icon="mdi-camera"
                    label="เลือกรูปภาพ"
                    outlined
                    rounded
                    dense
                    show-size
                    class="p-absolute center-row full-width"
                    v-model="imageFiles2"
                  ></v-file-input>
                </v-col>
                <v-col lg="6" md="6" sm="6" cols="12">
                  <v-card class="ma-5" :color="`grey lighten-2`" elevation="3">
                    <v-img
                      :src="imgPreview2 == null ? imageReady2 : imgPreview2"
                      :lazy-src="imgPreview2"
                      aspect-ratio="1.8"
                      contain
                      height="190"
                    >
                      <template v-slot:placeholder>
                        <v-row class="fill-height ma-0" align="center" justify="center">
                          <v-icon
                            v-if="imageReady2"
                            class="mx-auto"
                            elevation="3"
                            size="190"
                          >mdi-card-account-details-outline</v-icon>
                        </v-row>
                      </template>
                    </v-img>
                  </v-card>
                </v-col>
              </v-row>

              <v-divider class="mb-5"></v-divider>
              <p class="subtitle-1">คำอธิบาย</p>
              <v-textarea
                outlined
                name="input-7-4"
                placeholder="โปรดเขียนคำอธิบายเพื่อประกอบการพิจารณา"
                v-model="decription"
              ></v-textarea>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" dark rounded outlined @click="isClose">ยกเลิก</v-btn>
          <v-btn
            color="primary"
            rounded
            @click="confirm"
            :disabled="(!imgPreview1 && !imgPreview2) && !valid"
          >ส่งคำขอ</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="notiModal" persistent max-width="450">
      <v-card class="pt-5">
        <v-card-text>
          การ
          <strong>&nbsp;สมัครเป็นครู&nbsp;</strong> ของคุณเรียบร้อยแล้ว
          กรุณารอ
          <strong>&nbsp;การยืนยัน&nbsp;</strong> จาก admin
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="dialogSuccess">เสร็จสิ้น</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { uploadImage } from "@/service/upload/upload";
import { verifyTeacher } from "@/service/account/manageUser";
import warnningComponent from "../../components/warningAlert.vue";

export default {
  props: {
    isOpen: {
      type: Boolean
    },
    isClose: {
      type: Function
    }
  },
  components: {
    warnningComponent
  },
  data() {
    return {
      dialogNote: false,
      rules: [
        v => !!v || "กรุณาเลือกอัปโหลดรูปภาพ"
        // v => v.size < 2000000 || "กรุณาเลือกไฟล์ที่มีขนาดน้อยกว่า 2 MB"
      ],
      decriptionRules: [v => !!v || "dicreption is required"],
      imageFiles1: [],
      imageFiles2: [],
      imgPreview1: "",
      imgPreview2: "",
      imageReady1: true,
      imageReady2: true,
      decription: "",
      info: [],
      loadding: false,

      //image
      imageUrl1: "",
      imageUrl2: "",

      //warnning
      textWarning: "",
      typeWarning: "",
      showWarnnig: false,

      //modal
      notiModal: false,
      valid: true
    };
  },
  watch: {
    isOpen: async function(newValue) {
      if (newValue) {
        this.initialize();
      }
    }
  },
  computed: {
    fileRules() {
      const rules = [];
      const rule = v => !!v || "กรุณาเลือกอัปโหลดรูปภาพ";
      rules.push(rule);

      const rule2 = v =>
        (v && v.size < 20000000) || "กรุณาเลือกไฟล์ที่มีขนาดน้อยกว่า 20 MB";
      rules.push(rule2);

      return rules;
    }
  },
  methods: {
    async processFile() {
      this.imgPreview1 = URL.createObjectURL(this.imageFiles1);
    },
    async processFile2() {
      this.imgPreview2 = URL.createObjectURL(this.imageFiles2);
    },
    initialize() {
      console.log("$store.state", this.$store.state);
      this.imageFiles1 = [];
      this.imageFiles2 = [];
      this.imgPreview1 = "";
      this.imgPreview2 = "";

      this.decription = "";
      this.info = [];

      //image
      this.imageUrl1 = "";
      this.imageUrl2 = "";
      if (this.$store.state) {
        this.info = {
          image: this.$store.state.image,
          name: this.$store.state.displayName,
          email: this.$store.state.email,
          id: this.$store.state._id
        };
      }
      console.log(this.info);
    },
    async confirm() {
      this.loadding = true;
      console.log("this.imageFiles2", this.imageFiles2);

      this.imageUrl1 =
        this.imageFiles1.length !== 0
          ? await this.uploadImg(this.imageFiles1)
          : "";
      this.imageUrl2 =
        this.imageFiles2.length !== 0
          ? await this.uploadImg(this.imageFiles2)
          : "";

      //
      let status = await verifyTeacher({
        image: [this.imageUrl1, this.imageUrl2],
        description: this.decription
      });
      console.log("status", status);
      if (status.isTeacher == "w") {
        this.loadding = false;
        this.notiModal = true;
      }
    },
    async uploadImg(image) {
      let status = await uploadImage("user", image);
      return status;
    },
    warnnig(text, type) {
      (this.textWarning = text),
        (this.typeWarning = type),
        (this.showWarnnig = true);
      setInterval(() => {
        this.showWarnnig = false;
      }, 7000);
    },
    dialogSuccess() {
      this.isClose();
      this.notiModal = false;
      window.location.reload();
    }
  }
};
</script>
<style scoped>
.v-text-field--filled > .v-input__control > .v-input__slot,
.v-text-field--full-width > .v-input__control > .v-input__slot,
.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 40px;
}
.border {
  border: 1px solid #eeeeee;
  border-radius: 5px;
}
.preview {
  width: 100%;
  min-height: 300px;
}
.p-absolute {
  position: absolute;
}
.center-row {
  top: 50%;
  transform: translate(0, -50%);
}
.p-relative {
  position: relative;
}
.full-width {
  width: 90%;
}
.img-padding {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>